import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-text-button',
  templateUrl: './icon-text-button.component.html',
  styleUrls: ['./icon-text-button.component.scss'],
})
export class IconTextButtonComponent implements OnInit {
  @Input() text: string | undefined;
  @Input() imagePath: string | undefined;
  @Input() route: string | any[] | null | undefined;

  constructor() {}

  ngOnInit(): void {}
}
